import { render } from "./Yishengshenhe.vue?vue&type=template&id=052ac8e5&scoped=true"
import script from "./Yishengshenhe.vue?vue&type=script&lang=js"
export * from "./Yishengshenhe.vue?vue&type=script&lang=js"

import "./Yishengshenhe.vue?vue&type=style&index=0&id=052ac8e5&scoped=true&lang=css"

import exportComponent from "D:\\VSCODE_POJECT\\back-to-class-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052ac8e5"]])

export default __exports__